import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import { HybridServiceAccessor } from "@app/common/hybrid-service-accessor";
import { DriverScoreGraphComponent } from "@app/main/components/insights/driver-behaviour/driver-score-graph/driver-score-graph.component";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { DashboardNavigationService } from "./dashboard-navigation.service";
import { DashboardService } from "./dashboard.service";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { MetricWidgetComponent } from "./widgets/metric-widget/metric-widget.component";

export class Config {
  
    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        private $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider
    ) { 
        this.$stateProvider.state("app.dashboard", {
            url: "/dashboard",
            resolve: {
                redirect: ["$stateParams", "$injector", "$state", async ($stateParams, $injector, $state) => 
                    { 
                        const dashboardNavService = new HybridServiceAccessor<DashboardNavigationService>(
                            "dashboardNavigationService", 
                            $injector
                        );

                        const currentId = $stateParams["id"];

                        try {
                            const defaultDashboardId = await dashboardNavService.service.getDefaultId();

                            const id = await dashboardNavService.service.isIdValid(currentId)
                                ? currentId
                                : defaultDashboardId;

                             // just to prevent unnecessary console error that is handled anyway
                            return $state.go("app.dashboard.id", { id });
                        } catch { }
                    }
                ],
            }
        });

        this.$stateProvider.state("app.dashboard.id", {
            url: "/:id",
            views: { "content@app": { component: "dashboardv3" } },
            data: { title: 'Dashboard' },
        });
    }
}

angular
    .module("app.dashboard", [/*"app.directives", "dndLists"*/])
    .config(Config)

    .directive("dashboardv3", downgradeComponent({ component: DashboardComponent }))
    .directive("dashboardWidget", downgradeComponent({ component: MetricWidgetComponent }))
    .directive("driverScoreGraph", downgradeComponent({ component: DriverScoreGraphComponent }))

    .service("dashboardNavigationService", downgradeInjectable(DashboardNavigationService))
    .service("dashboardService", downgradeInjectable(DashboardService))